<template>
  <el-form
    :model="formData"
    :rules="rules"
    ref="formRef"
    label-width="140px"
    label-suffix="："
  >
    <el-form-item label="结算模式:" prop="settlementModel">
      <el-select
        clearable
        v-model="formData.settlementModel"
        filterable
        placeholder="请选择结算模式"
      >
        <el-option
          v-for="(item, index) in settlementModellist"
          :key="index"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="公司名称:" prop="companyId">
      <el-select
        :disabled="formData.status == 2"
        clearable
        v-model="formData.companyId"
        filterable
        placeholder="请选择公司名称"
        @change="changeNameGetapp"
      >
        <el-option
          v-for="item in CompanyNameList"
          :key="item.id"
          :label="item.companyName"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="应用名称:" prop="appId">
      <el-select
        clearable
        v-model="formData.appId"
        filterable
        placeholder="请选择应用名称"
      >
        <el-option
          v-for="item in appList"
          :key="item.appId"
          :label="item.appName"
          :value="item.appId"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="结算周期:" prop="date">
      <el-date-picker
        type="daterange"
        range-separator="至"
        v-model="formData.date"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
    </el-form-item>
    <el-form-item label="扣款金额" prop="amount">
      <el-input
        :disabled="formData.status == 2"
        v-model="formData.amount"
        placeholder="请输入扣款金额"
        type="number"
        min="0"
      >
      </el-input>
    </el-form-item>
    <el-form-item label="备注">
      <el-input v-model="formData.remark" placeholder="请输入备注"> </el-input>
    </el-form-item>
    <el-form-item label="商务邮箱" prop="email">
      <el-input v-model="formData.email" placeholder="请输入商务邮箱">
      </el-input>
    </el-form-item>
    <el-form-item label="结算数据" prop="authDocUrl">
      <div class="upFc">
        <div class="imgFile">
          <div
            v-for="(url, index) in imgChangeType(imgUrlList)"
            :key="url"
            class="file-item"
          >
            <el-image
              :preview-teleported="true"
              class="image"
              :src="url"
              :preview-src-list="imgChangeType(imgUrlList)"
            >
            </el-image>
            <i
              class="el-icon-close cursor ml10"
              @click="handleRemoveFile(url)"
            ></i>
          </div>
          <div
            class="file-item"
            v-for="(url, index) in pdfChangeType(imgUrlList)"
            :key="url"
          >
            <img
              class="image"
              src="../../../../assets/images/excel.png"
              alt=""
              @click="lokinfoPDf(url)"
            />
            <i
              class="el-icon-close cursor ml10"
              @click="handleRemoveFile(url)"
            ></i>
            <!-- 新增的显示文件名的 span -->
            <span class="file-name">{{ getFileName(url) }}</span>
          </div>
        </div>

        <!-- <div class="imgFile" v-for="(item, index) in imgUrlList" :key="index">
          <img :src="item" alt="" />
          <div class="textWinth">
            <span></span>
            <el-tooltip :content="changeUrl(item)" placement="top-start">
              <span>{{ changeUrl(item) }}</span>
            </el-tooltip>
            <i
              class="el-icon-close cursor ml10"
              @click="handleRemoveFile(index)"
            ></i>
          </div>
        </div> -->
        <UploadFile
          class="UploadFileClass"
          textString="添加"
          :limSize="5"
          v-model="formData.authDocUrl"
          type="other"
          :acceptType="[
            'png',
            'jpg',
            'jpeg',
            'vnd.ms-excel',
            'vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          ]"
          @success="(file) => handleSuccessUpload(file)"
        >
        </UploadFile>
      </div>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="handleSubmit()">立即提交</el-button>
      <el-button @click="handleCancel()">返回</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
import UploadFile from "@/components/UploadFile1.vue";
import { sceneTypeList, sellPositionList } from "@/common/constant/constant.js";
import { getAppList } from "./indexServe";
export default {
  components: { UploadFile },
  props: {
    detailData: {
      type: Object,
      default() {
        return {};
      },
    },
    operationType: { default: "" },
    CompanyNameList: { default: [] },
  },
  data() {
    const checkNum = function (rule, value, callback) {
      if (value && isNaN(value)) {
        callback(Error("请输入数字"));
      } else {
        callback();
      }
    };
    return {
      imgUrlList: [],
      appList: [],
      settlementModellist: [
        {
          label: "CPA",
          value: "CPA",
        },
        {
          label: "CPR",
          value: "CPR",
        },
      ],
      sceneTypeList,
      sellPositionList,
      formData: {
        date: [],
        authDocUrl: "",
      },
      rules: {
        settlementModel: [{ required: true, message: "请选择结算模式" }],
        companyId: [{ required: true, message: "请选择公司名称" }],
        appId: [{ required: true, message: "请选择应用名称" }],
        maxPercent: [
          { required: true, message: "请输入上涨波动阈值" },
          { validator: checkNum },
        ],
        minPercent: [
          { required: true, message: "请输入下降波动阈值" },
          { validator: checkNum },
        ],
        date: [{ required: true, message: "请选择结算周期" }],
        amount: [{ required: true, message: "请选择扣款金额" }],
        remark: [{ required: true, message: "请输入备注" }],
        email: [{ required: true, message: "请输入商务邮箱" }],
        authDocUrl: [{ required: true, message: "请添加结算数据" }],
      },
    };
  },
  computed: {
    disabled() {
      return this.operationType === "edit";
    },
  },
  methods: {
    lokinfoPDf(url) {
      window.open(url, "_blank");
    },
    imgChangeType(arr) {
      let arrayData = [];

      try {
        // 情况1：如果是字符串，尝试解析为JSON数组
        if (typeof arr === "string") {
          // 去除可能存在的前后空格（避免解析失败）
          const trimmedStr = arr.trim();
          // 只有看起来像数组的字符串才尝试解析
          if (trimmedStr.startsWith("[") && trimmedStr.endsWith("]")) {
            arrayData = JSON.parse(trimmedStr);
          } else {
            // 不像数组的字符串，直接包装成数组
            arrayData = [trimmedStr];
          }
        }
        // 情况2：如果已经是数组，直接使用
        else if (Array.isArray(arr)) {
          arrayData = arr;
        }
        // 情况3：其他类型，包装成数组
        else {
          arrayData = [arr];
        }

        // 确保最终是数组（防止解析失败）
        if (!Array.isArray(arrayData)) {
          arrayData = [arr];
        }

        // 筛选xls和xlsx文件
        return arrayData.filter((element) => {
          return (
            typeof element === "string" &&
            (element.endsWith(".jpg") ||
              element.endsWith(".png") ||
              element.endsWith(".jpeg"))
          );
        });
      } catch (e) {
        console.error("解析数据出错:", e);
        return []; // 出错时返回空数组，避免崩溃
      }
    },
    pdfChangeType(arr) {
      let arrayData = [];

      try {
        // 情况1：如果是字符串，尝试解析为JSON数组
        if (typeof arr === "string") {
          // 去除可能存在的前后空格（避免解析失败）
          const trimmedStr = arr.trim();
          // 只有看起来像数组的字符串才尝试解析
          if (trimmedStr.startsWith("[") && trimmedStr.endsWith("]")) {
            arrayData = JSON.parse(trimmedStr);
          } else {
            // 不像数组的字符串，直接包装成数组
            arrayData = [trimmedStr];
          }
        }
        // 情况2：如果已经是数组，直接使用
        else if (Array.isArray(arr)) {
          arrayData = arr;
        }
        // 情况3：其他类型，包装成数组
        else {
          arrayData = [arr];
        }

        // 确保最终是数组（防止解析失败）
        if (!Array.isArray(arrayData)) {
          arrayData = [arr];
        }

        // 筛选xls和xlsx文件
        return arrayData.filter((element) => {
          return (
            typeof element === "string" &&
            (element.endsWith(".xls") || element.endsWith(".xlsx"))
          );
        });
      } catch (e) {
        console.error("解析数据出错:", e);
        return []; // 出错时返回空数组，避免崩溃
      }
      // let arrAy = arr.split(",");
      // if (arr && arr.length > 0) {
      //   return arr.filter((element) =>
      //     element.endsWith(".pdf" || ".xlsx" || ".xls")
      //   );
      // } else {
      //   return "";
      // }
    },
    getFileName(url) {
      const arr = url.split("/"); // 按路径分隔，若 url 是纯文件名则可省略，根据实际情况调整
      return arr[arr.length - 1];
    },
    changeUrl(url) {
      const fullFileName = url.split("/").pop();
      return fullFileName;
    },
    handleSuccessUpload(file) {
      console.log(file, this.imgUrlList, "看一下图片");
      if (this.imgUrlList.length >= 5) {
        return;
      }
      if (file) {
        this.imgUrlList.push(file.accessPath);
      }
    },
    uploadSuccess(file) {
      // this.formData.accessFilePath = file.accessPath;
      // this.formData.accessFileId = file.fileId;
      // this.formData.fileName = file.fileName;
      this.$refs.formRef.clearValidate("accessPath");
    },
    handleRemoveFile(url) {
      let indices;
      indices = this.imgUrlList.indexOf(url, 0);
      this.imgUrlList.splice(indices, 1);
    },
    changeNameGetapp(e) {
      this.appList = [];
      this.$set(this.formData, "appId", "");
      if (e) {
        this.getAppList(e);
      }
    },
    async getAppList(id) {
      let data = {
        id: id,
      };
      const res = await getAppList(data);
      if (res && res.code === 0) {
        this.appList = res.data;
      }
    },
    handleChangeSceneType() {
      // 清空已选的推荐版位
      this.formData.sellPosition = "";
    },
    handleSubmit() {
      let that_ = this;
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          const { settlementModel, companyId, appId, amount, remark, email } =
            that_.formData;

          const data = {
            settlementModel: settlementModel,
            appId: appId,
            amount: amount,
            companyId: companyId,
            remark: remark,
            email: email,
            settlementData: [],
          };
          data.amount = Number(data.amount);
          if (that_.imgUrlList.length > 0) {
            that_.imgUrlList.forEach((res) => {
              data.settlementData.push(res);
            });
          }
          if (this.operationType != "create") {
            data.id = that_.formData.id;
          }
          if (data) {
            data.startTime = this.formData.date[0];
            data.endTime = this.formData.date[1];
          }
          this.$emit("submit", data);
        }
      });
    },
    handleCancel() {
      this.$emit("cancel");
    },
    // 其他
    initData(data) {
      this.formData = {
        ...data,
        date: [],
      };
      if (this.operationType != "create") {
        this.formData.date = [data.startCycle, data.endCycle];
        this.imgUrlList = JSON.parse(this.formData.settlementData);
        console.log(this.imgUrlList, "结算数据");

        this.getAppList(this.formData.companyId);
        this.formData.authDocUrl = this.imgUrlList[0];
      }
    },
  },
  watch: {
    detailData: {
      immediate: true,
      handler(data) {
        this.initData(data);
        if (this.operationType === "create") {
          this.$refs.formRef && this.$refs.formRef.resetFields();
        }
      },
    },
  },
};
</script>
<style scoped lang="scss">
.textWinth {
  margin-top: -10px;
  line-height: 18px;
}
.el-input,
.el-select {
  width: 500px;
}
.imgFile {
  // width: 100px;
  flex-wrap: wrap;
  margin-right: 15px;
  display: flex;
  .image {
    width: 100px;
    height: 100px;
    margin: 10px;
  }
  img {
    width: 100px;
    height: 100px;
    margin: 10px;
    cursor: pointer;
  }
  .file-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    margin: 15px;
    width: 100px;
  }
  span {
    white-space: pre-wrap;
    line-height: 1;
  }
  .cursor {
    position: absolute;
    top: -5px;
    right: -20px;
    display: inline-block;
    width: 20px;
    height: 20px;
  }
}
.upFc {
  display: flex;
}
.UploadFileClass {
  margin-left: 20px;
}
</style>
